import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import Separator from '../../../../../components/Simple/Sepperator';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import SMCTextArea from '../../../../../components/Simple/SMCTextArea';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.cliScript3;
const pageId = pageSchema.pageId;

function BaseCliScript3({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();

    const managedInSmp = pageData[pageSchema.manageInSmp];
    const script       = pageData[pageSchema.script];

    const setPageValue = useCallback((param, newValue) => {
        if (!pageDisabled) {
            setObjectData([pageId, param], newValue);
        }
    }, [setObjectData, pageDisabled]);

    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={managedInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            {/* CLI script */}
            <SMCLabel>{t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.ENTER_A_CLI_SCRIPT')}</SMCLabel>
            <SMCTextArea
                disabled={pageDisabled || !managedInSmp}
                value={script}
                onChange={e => setPageValue(pageSchema.script, e.target.value)}
                width="580px"
                height="140px"
                style={{ fontFamily: 'monospace' }}
            />
            <SMCLabel>{t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.NOTE_REMOTE_CLI_SCRIPT')}</SMCLabel>
        </EditorLayout>
    );
}

export default BaseCliScript3;